exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".model-selection-section,\n.package-mapping-section {\n  margin-bottom: 24px;\n}\n.model-selection-section h3,\n.package-mapping-section h3 {\n  margin-bottom: 16px;\n  font-weight: 500;\n}\n.model-selection-section .ant-table .ant-table-thead > tr > th,\n.package-mapping-section .ant-table .ant-table-thead > tr > th {\n  background-color: #fafafa;\n  font-weight: 500;\n}\n.model-selection-section {\n  margin-top: 24px;\n}\n", ""]);

// exports
